module.exports = __webpack_public_path__ + "static/img/8.7800637.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/zh/8.png
// module id = oGSK
// module chunks = 0